import {
    GET_GXT_DATA,
    GET_GXT_DOCUMENT,
    GET_GXT_LIST_DATA,
    GXT_DOC_LOADING,
    RESET_GXT_MODAL,
    SET_GXT_LOADING,
    CLEAR_GXT,
} from './gxtList.type'
import axios from 'axios'
import { toggleDeactivateModal, toggleSessionModal } from '../../modals/toggleModal.actions'

export const getGxtListData = (payload, token) => async (dispatch) => {
    dispatch({
        type: SET_GXT_LOADING,
        payload: true,
    })
    axios
        .post(`${process.env.REACT_APP_CARD_URL}/gxt/list`, payload, {
            headers: {
                accessToken: token,
            },
        })
        .then((response) => {
            if (response.data.status === 200) {
                dispatch({
                    type: GET_GXT_LIST_DATA,
                    payload: response.data.output,
                })
                dispatch({
                    type: SET_GXT_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 401) {
                dispatch(toggleSessionModal(true, response?.data?.error))
                dispatch({
                    type: SET_GXT_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 403) {
                dispatch(toggleDeactivateModal(true))
                dispatch({
                    type: SET_GXT_LOADING,
                    payload: false,
                })
            }
        })
        .catch((err) => {
            // console.log(err)
        })
}

export const getGxtData = (payload, token) => async (dispatch) => {
    dispatch({
        type: SET_GXT_LOADING,
        payload: true,
    })
    axios
        .post(`${process.env.REACT_APP_CARD_URL}/gxt/view`, payload, {
            headers: {
                accessToken: token,
            },
        })
        .then((response) => {
            if (response.data.status === 200) {
                dispatch({
                    type: GET_GXT_DATA,
                    payload: response.data.output,
                })
                dispatch({
                    type: SET_GXT_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 401) {
                dispatch(toggleSessionModal(true, response?.data?.error))
                dispatch({
                    type: SET_GXT_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 403) {
                dispatch(toggleDeactivateModal(true))
                dispatch({
                    type: SET_GXT_LOADING,
                    payload: false,
                })
            }
        })
        .catch((err) => {
            // console.log(err)
        })
}

export const getGxtDocument = (payload, token) => async (dispatch) => {
    dispatch({
        type: GXT_DOC_LOADING,
        payload: true,
    })
    axios
        .post(`${process.env.REACT_APP_CARD_URL}/gxt/list-documents`, payload, {
            headers: {
                accessToken: token,
            },
        })
        .then((response) => {
            if (response.data.status === 200) {
                dispatch({
                    type: GET_GXT_DOCUMENT,
                    payload: response.data.output,
                })
                dispatch({
                    type: GXT_DOC_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 401) {
                dispatch(toggleSessionModal(true, response?.data?.error))
                dispatch({
                    type: GXT_DOC_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 403) {
                dispatch(toggleDeactivateModal(true))
                dispatch({
                    type: GXT_DOC_LOADING,
                    payload: false,
                })
            }
        })
        .catch((err) => {
            // console.log(err)
        })
}

export const resetGxtDocument = () => (dispatch) => {
    dispatch({
        type: RESET_GXT_MODAL,
    })
}

export const clearGxt = () => (dispatch) => {
    dispatch({
        type: CLEAR_GXT,
    })
}
